import belarusArea from './belarusArea';
import Validation from '../../common/assets/js/validation';
import mainConfig from '../../mainConfig';
import InputMask from '../../common/assets/js/inputMask';

export default new class AddRentPoint {
    constructor() {
        this.$document = $(document);

        this.phoneItem = '.js-phoneItem';
        this.addPhoneBtn = '.js-addPhone';
        this.deletePhoneBtn = '.js-deletePhone';
        this.createRentPointBtn = '.js-createRentPoint';
        this.deleteRentPointBtn = '.js-deleteRentPoint';
        this.dayOffCheckbox = 'input.js-dayOffCheckbox';
        this.dayContainer = '.js-dayContainer';
        this.timeMaskElems = '.js-workingHoursInput';
        this.isFormSubmitted = false;

        this.wrapper = '.add-rent-point';
        this.$wrapper = $(this.wrapper);
        this.regionId = this.$wrapper.find('input[name="region_id"]');
        this.latInput = this.$wrapper.find('input[name="lat"]');
        this.lngInput = this.$wrapper.find('input[name="lng"]');
        this.lat = this.latInput.length > 0 ? this.latInput.val().trim() : '';
        this.lng = this.lngInput.length > 0 ? this.lngInput.val().trim() : '';
        this.coords = [this.lat, this.lng];

        this.updateAdress = false;

        this.map = {};
        this.placemark;
        this.polygon;

        this.dataAreaName = {
            'Минск': 'Минская область',
            'Гродно': 'Гродненская область',
            'Брест': 'Брестская область',
            'Гомель': 'Гомельская область',
            'Могилев': 'Могилёвская область',
            'Витебск': 'Витебская область'
        };

        this.regionIndex = {
            'Брестская область': 3,
            'Витебская область': 5,
            'Гомельская область': 4,
            'Гродненская область': 6,
            'Минская область': 1,
            'Могилевская область': 2,
            'Могилёвская область': 2
        };

        this.area = '._map-area';
        this.city = '._map-city';
        this.address = '._map-address';

        this.bindEvents();
        this.renderDeletePhoneBtns();
    }
    
    bindEvents () {
        this.$document.on('click', this.dayOffCheckbox, (e) => {
            this.disableTimeMode($(e.target));
        });
        this.$document.on('click', this.createRentPointBtn, (e) => {
            let $form = $(e.target).closest('form');

            if (Validation.isFormValid($form) && !this.isFormSubmitted) {
                this.isFormSubmitted = true;
            } else {
                e.preventDefault();
            }
        });
        this.$document.on('click', this.deleteRentPointBtn, (e) => {
        });
        this.$document.on('click', this.addPhoneBtn, (e) => {
            e.preventDefault();

            this.addPhone();
        });
        this.$document.on('click', this.deletePhoneBtn, (e) => {
            e.preventDefault();

            this.deletePhone($(e.target));
        });
    }

    renderDeletePhoneBtns () {
        let phoneItems = $(this.phoneItem);

        if (phoneItems.length > 1) {
            for (var i = 0; i < phoneItems.length; i++) {
                if (i != 0) {
                    $(phoneItems[i]).append('<div class="form__input-button js-deletePhone">Удалить поле</div>');
                }
            }
        }
    }

    addPhone() {
        let $phoneItem = $(this.phoneItem),
            $itemToAppend = $($phoneItem.clone()[0]),
            lastPhone = $phoneItem.last(),
            inputToAdd = $itemToAppend.find('input');

        $itemToAppend.find('label').remove();
        inputToAdd.val('');
        inputToAdd.removeClass(mainConfig.errorMessages.inputErrorClassName);
        $itemToAppend.insertAfter(lastPhone);

        if ($phoneItem.length == 4) {
            $(this.addPhoneBtn).hide();
        }
        this.renderDeletePhoneBtns();
        InputMask.setPhoneMask();
    }

    deletePhone ($deleteBtn) {
        let $phoneItem = $(this.phoneItem);

        if (!($phoneItem.length == 1)) {
            $deleteBtn.closest(this.phoneItem).remove();
        }
        if ($phoneItem.length == 5) {
            $(this.addPhoneBtn).show();
        }
    }

    disableTimeMode($checkbox) {
        let inputs = $checkbox.closest(this.dayContainer).find(this.timeMaskElems),
            isDisabled = $checkbox.prop('checked');

        for (var i = 0; i < inputs.length; i++) {
            $(inputs[i]).removeClass(mainConfig.errorMessages.inputErrorClassName);
            inputs[i].disabled = isDisabled;
            inputs[i].value = '';
        }
    }

    mapInit() {
        $.getScript(mainConfig.yandexScriptSrc, () => {
            ymaps.ready(this.createMap.bind(this));
        });
    }

    createMap() {
        if(Object.keys(this.map).length) {
            this.map.destroy();
        }

        this.map = new ymaps.Map('add-point-map', {
            center: [53.9, 27.5667],
            zoom: 7,
            controls: ['zoomControl']
        });

        this.createPolygon();
        this.addPlacemark();
    }

    createPolygon() {
        this.polygon = new ymaps.Polygon(belarusArea, {
            hintContent: 'Oбласть ограничения'
        }, {
            fillColor: '#008200',
            strokeColor: '#008200',
            interactivityModel: 'default#transparent',
            strokeWidth: 2,
            strokeOpacity: 0.5,
            fillOpacity: 0.1
        });
        this.map.geoObjects.add(this.polygon);
    }

    addPlacemark() {
        if(this.lat.length > 0 && this.lng.length > 0) {
            this.addNewPlacemark(this.coords);
            this.getAddress(this.coords, true);
        }

        this.map.events.add('click', e => {
            let coords = e.get('coords');
            this.updateAdress = true;

            let clickResult = ymaps.geoQuery(ymaps.geocode(coords)).searchInside(this.polygon).then(() => {
                if(!clickResult.get(0)) {
                    return;
                }
                if(this.placemark) {
                    this.placemark.geometry.setCoordinates(coords);
                }
                else {
                    this.addNewPlacemark(coords);
                }
                this.getAddress(coords);
                this.setNewCoordsInValue(coords);
            });
        });
    }

    addNewPlacemark(coords) {
        this.placemark = this.createPlacemark(coords);
        this.map.geoObjects.add(this.placemark);
        this.placemark.events.add('dragend', () => {
            let dragendResult = ymaps.geoQuery(ymaps.geocode(this.placemark.geometry.getCoordinates())).searchInside(this.polygon).then(() => {
                if (!dragendResult.get(0)) {
                    this.removePlacemark();
                    return;
                }
                this.getAddress(this.placemark.geometry.getCoordinates());
                this.setNewCoordsInValue(this.placemark.geometry.getCoordinates());
            });
        });
    }

    setNewCoordsInValue(coords) {
        this.latInput.val(coords[0]);
        this.lngInput.val(coords[1]);
    }

    createPlacemark(coords) {
        return new ymaps.Placemark(coords, {
            iconCaption: 'поиск...'
        }, {
            preset: 'islands#blueDotIconWithCaption',
            draggable: true
        });
    }

    getAddress(coords) {
        this.placemark.properties.set('iconCaption', 'поиск...');
        ymaps.geocode(coords).then((res) => {
            let firstGeoObject = res.geoObjects.get(0);
            this.fillingFields(firstGeoObject.properties.get('metaDataProperty.GeocoderMetaData'));
            this.placemark.properties.set({
                iconCaption: firstGeoObject.properties.get('name'),
                balloonContent: firstGeoObject.properties.get('text')
            });
        });
    }

    removePlacemark() {
        this.map.geoObjects.remove(this.placemark);
        this.placemark = null;
    }

    fillingFields(metaData, noFilling) {
        let $area = $(this.area),
            $city = $(this.city),
            $address = $(this.address),
            LocalityData = this.checkMetadata(metaData);

        if(LocalityData.AdministrativeAreaName && !LocalityData.LocalityName && this.dataAreaName[LocalityData.AdministrativeAreaName]) {
            LocalityData.LocalityName = LocalityData.AdministrativeAreaName;
        }

        if(LocalityData.LocalityName && LocalityData.AdministrativeAreaName == LocalityData.LocalityName) {
            LocalityData.AdministrativeAreaName = this.dataAreaName[LocalityData.LocalityName];
        }

        $area.val(LocalityData.AdministrativeAreaName);
        $city.val(LocalityData.LocalityName);

        if (noFilling) {
            return;
        }

        let addressTextDLN = `${LocalityData.DependentLocalityName && (LocalityData.ThoroughfareName || LocalityData.PremiseNumber) ? LocalityData.DependentLocalityName + ', ' : LocalityData.DependentLocalityName}`,
            addressTextTN = `${LocalityData.ThoroughfareName && LocalityData.PremiseNumber ? LocalityData.ThoroughfareName + ', ' : LocalityData.ThoroughfareName}`,
            addressTextPN = LocalityData.PremiseNumber;

        //update address only if field empty or user changed address by set placemark on the map
        if (!$address.val().length || this.updateAdress) {
            $address.val(`${addressTextDLN}${addressTextTN}${addressTextPN}`);

            this.updateAdress = false;
        }

        $address.removeClass(mainConfig.errorMessages.inputErrorClassName);
        this.regionId.val(this.regionIndex[LocalityData.AdministrativeAreaName]);
    }

    checkMetadata(metaData) {
        let Country = metaData.AddressDetails.Country,
            CountryName = Country.CountryName ? Country.CountryName : '',// страна
            AdministrativeAreaName = Country.AdministrativeArea && Country.AdministrativeArea.AdministrativeAreaName ? Country.AdministrativeArea.AdministrativeAreaName : '', // область
            LocalityName, // город
            DependentLocalityName, // район
            ThoroughfareName, // улица
            PremiseNumber; // дом

        if(Country.AdministrativeArea && Country.AdministrativeArea.Locality) {
            LocalityName = Country.AdministrativeArea.Locality.LocalityName ? Country.AdministrativeArea.Locality.LocalityName : '';
            DependentLocalityName = Country.AdministrativeArea.Locality.DependentLocality ? Country.AdministrativeArea.Locality.DependentLocality.DependentLocalityName : '';
            ThoroughfareName = Country.AdministrativeArea.Locality.Thoroughfare ? Country.AdministrativeArea.Locality.Thoroughfare.ThoroughfareName : Country.AdministrativeArea.Locality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.Thoroughfare ? Country.AdministrativeArea.Locality.DependentLocality.Thoroughfare.ThoroughfareName : Country.AdministrativeArea.Locality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.DependentLocality.Thoroughfare ? Country.AdministrativeArea.Locality.DependentLocality.DependentLocality.Thoroughfare.ThoroughfareName : '';
            PremiseNumber = Country.AdministrativeArea.Locality.Thoroughfare && Country.AdministrativeArea.Locality.Thoroughfare.Premise ? Country.AdministrativeArea.Locality.Thoroughfare.Premise.PremiseNumber : Country.AdministrativeArea.Locality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.Thoroughfare && Country.AdministrativeArea.Locality.DependentLocality.Thoroughfare.Premise ? Country.AdministrativeArea.Locality.DependentLocality.Thoroughfare.Premise.PremiseNumber : Country.AdministrativeArea.Locality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.DependentLocality && Country.AdministrativeArea.Locality.DependentLocality.DependentLocality.Thoroughfare && Country.AdministrativeArea.Locality.DependentLocality.DependentLocality.Thoroughfare.Premise ? Country.AdministrativeArea.Locality.DependentLocality.DependentLocality.Thoroughfare.Premise.PremiseNumber : '';
        } else if(Country.AdministrativeArea && Country.AdministrativeArea.SubAdministrativeArea) {
            LocalityName = Country.AdministrativeArea.SubAdministrativeArea.Locality && Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName ? Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName : '';
            DependentLocalityName = Country.AdministrativeArea.SubAdministrativeArea.Locality && Country.AdministrativeArea.SubAdministrativeArea.Locality.DependentLocality ? Country.AdministrativeArea.SubAdministrativeArea.Locality.DependentLocality.DependentLocalityName : Country.AdministrativeArea.SubAdministrativeArea.SubAdministrativeAreaName ? Country.AdministrativeArea.SubAdministrativeArea.SubAdministrativeAreaName : '';
            ThoroughfareName = Country.AdministrativeArea.SubAdministrativeArea.Locality && Country.AdministrativeArea.SubAdministrativeArea.Locality.Thoroughfare ? Country.AdministrativeArea.SubAdministrativeArea.Locality.Thoroughfare.ThoroughfareName : '';
            PremiseNumber = Country.AdministrativeArea.SubAdministrativeArea.Locality && Country.AdministrativeArea.SubAdministrativeArea.Locality.Thoroughfare && Country.AdministrativeArea.SubAdministrativeArea.Locality.Thoroughfare.Premise ? Country.AdministrativeArea.SubAdministrativeArea.Locality.Thoroughfare.Premise.PremiseNumber : '';
        } else if(Country.Country && Country.Country.Locality) {
            ThoroughfareName = Country.Country.Locality.Premise.PremiseName;
            PremiseNumber = '';
        } else {
            AdministrativeAreaName = '';
            LocalityName = '';
            DependentLocalityName = '';
            ThoroughfareName = '';
            PremiseNumber = '';
        }
        return { CountryName, AdministrativeAreaName, LocalityName, DependentLocalityName, ThoroughfareName, PremiseNumber };
    }
};



// WEBPACK FOOTER //
// ./src/pages/account-rent-points-create/AddRentPoint.js